"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const CardsContext = (0, react_1.createContext)({
    blueCardButtonText: '',
    blueCardLink: '',
    blueCardText: '',
    data: {},
    blueCardImage: '',
    whiteCardButtonLink: '',
    showDesc: false,
    showExcerpt: false,
    tabbed: false,
    whiteCardModalButtonText: '',
    whiteCardsButtonText: '',
});
exports.default = CardsContext;
